import { render, staticRenderFns } from "./fee.vue?vue&type=template&id=c6c2ad0c"
import script from "./fee.vue?vue&type=script&lang=ts"
export * from "./fee.vue?vue&type=script&lang=ts"
import style0 from "./fee.vue?vue&type=style&index=0&id=c6c2ad0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports